import React from "react";
import { HeaderAction, HeaderComponent } from "../../../types";
import { renderIcon } from "../../../utils/icons";
import EnhancedMenuEditor from "../../ui/EnhancedMenuEditor";
import VisibilitySettings from "./VisibilitySettings";

interface NavItemsSettingsProps {
	component: HeaderComponent;
	dispatch: React.Dispatch<HeaderAction>;
	onBackClick: () => void;
}

const NavItemsSettings: React.FC<NavItemsSettingsProps> = ({
	component,
	dispatch,
	onBackClick,
}) => {
	return (
		<div className="p-4">
			<div className="flex items-center mb-4">
				<button
					className="mr-2 p-1 rounded hover:bg-gray-100"
					onClick={onBackClick}>
					{renderIcon("menu", 16)}
				</button>
				<h3 className="text-lg font-medium">
					Navigation Items Settings
				</h3>
			</div>

			<div className="mb-4">
				<label className="block text-sm font-medium mb-1">
					Space Between Items
				</label>
				<input
					type="text"
					className="w-full p-2 border rounded"
					value={component.styles?.gap || "16px"}
					onChange={(e) =>
						dispatch({
							type: "UPDATE_COMPONENT",
							payload: {
								id: component.id,
								updates: {
									styles: {
										...component.styles,
										gap: e.target.value,
									},
								},
							},
						})
					}
				/>
			</div>

			{/* Font Weight Setting */}
			<div className="mb-4">
				<label className="block text-sm font-medium mb-1">
					Font Weight
				</label>
				<select
					className="w-full p-2 border rounded"
					value={component.settings?.fontWeight || "normal"}
					onChange={(e) =>
						dispatch({
							type: "UPDATE_COMPONENT",
							payload: {
								id: component.id,
								updates: {
									settings: {
										...component.settings,
										fontWeight: e.target.value,
									},
									styles: {
										...component.styles,
										fontWeight: e.target.value,
									},
								},
							},
						})
					}>
					<option value="normal">Normal</option>
					<option value="bold">Bold</option>
					<option value="light">Light</option>
					<option value="medium">Medium</option>
					<option value="semibold">Semibold</option>
				</select>
			</div>

			{/* Text Decoration Setting */}
			<div className="mb-4">
				<label className="block text-sm font-medium mb-1">
					Text Decoration
				</label>
				<select
					className="w-full p-2 border rounded"
					value={component.settings?.textDecoration || "none"}
					onChange={(e) =>
						dispatch({
							type: "UPDATE_COMPONENT",
							payload: {
								id: component.id,
								updates: {
									settings: {
										...component.settings,
										textDecoration: e.target.value,
									},
									styles: {
										...component.styles,
										textDecoration: e.target.value,
									},
								},
							},
						})
					}>
					<option value="none">None</option>
					<option value="underline">Underline</option>
					<option value="overline">Overline</option>
					<option value="line-through">Line Through</option>
				</select>
			</div>

			{/* Font Style Setting */}
			<div className="mb-4">
				<label className="block text-sm font-medium mb-1">
					Font Style
				</label>
				<select
					className="w-full p-2 border rounded"
					value={component.settings?.fontStyle || "normal"}
					onChange={(e) =>
						dispatch({
							type: "UPDATE_COMPONENT",
							payload: {
								id: component.id,
								updates: {
									settings: {
										...component.settings,
										fontStyle: e.target.value,
									},
									styles: {
										...component.styles,
										fontStyle: e.target.value,
									},
								},
							},
						})
					}>
					<option value="normal">Normal</option>
					<option value="italic">Italic</option>
					<option value="oblique">Oblique</option>
				</select>
			</div>

			<EnhancedMenuEditor component={component} dispatch={dispatch} />

			<VisibilitySettings component={component} dispatch={dispatch} />
		</div>
	);
};

export default NavItemsSettings;
